<template>
  <div id="omz-attendance" :class="`${type === 'modal' || type}`">
    <!-- {{ usrAttend }} -->
    <div :class="`day day${i} ${type === 'modal' || type}`" v-for="i in 7" :key="i">
      <img
        width="100%"
        class="omc-book"
        :src="`${$s3}/img/${lang}/event/omz_attend/${type}/${i <= usrAttend ? '' : 'default/'}${img(i)}.webp?${$ver}`"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'OMZAttendance',
  props: ['usrAttend', 'type'],
  computed: {
    ...mapState(['lang']),
  },
  methods: {
    img(num) {
      switch (num) {
        case 3:
        case 4:
        case 5:
        case 6:
          return 'default';

        default:
          return num;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

$border-right-list: 1, 2, 4, 5;

#omz-attendance {
  border-radius: 4px;
  border: 1px solid rgba(149, 122, 113, 0.21);
  width: 543px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(3, auto);
  grid-template-areas:
    'day1 day2 day3'
    'day4 day5 day6'
    'day7 day7 day7';

  @include mobile {
    width: 100%;
  }

  &.sidebar {
    width: 100%;
    padding: 0;
  }

  @for $i from 1 through 7 {
    .day#{$i} {
      grid-area: day#{$i};
    }
  }
  @for $i from 1 through 6 {
    .day#{$i} {
      border-bottom: 1px solid rgba(149, 122, 113, 0.21);
    }
  }
  @each $i in $border-right-list {
    .day#{$i} {
      border-right: 1px solid rgba(149, 122, 113, 0.21);
    }
  }

  .day {
    padding: 5px 10px;

    @include mobile {
      padding: 2.5px 5px;
    }

    &.day7 {
      padding: 10px;

      @include mobile {
        padding: 5px;
      }
    }

    &.sidebar {
      padding: 5px;
    }
  }
}
</style>
